import React, { Fragment } from 'react';
import { Button, Card, CardBody, Container, Row, Col } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useQualityControL } from '../../../hooks/Pbi/useQualityControL';
import { ModalQuality } from './ModalQuality';
import { ToastAletGlobal } from '../../alertDialog/ToastAletGlobal';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';



export const IndexQualityControL = () => {


	const {

		// ? CRUD
		listQuality,
		handleCreate,
		saveCreateCharacteristic,
		saveUpdateCharacteristic,
		handleUpdate,
		handleDelete,
		formValues,
		handleInputChange,
		validaciones,
		saveDelete,
		exportExcel,


		// ? DIALOG
		loading,
		visible,
		method,
		setVisible,
		tittleDialog,


		// ? ALERTS
		showToast,
		toastType,
		toastTitle,
		toastMessage,
		closeToastAlert,


		// ? FILTERS
		globalFilter,
		setGlobalFilter,
		filterData


	} = useQualityControL();


	// * TABLE
	const headerStyle = {
		backgroundColor: "#1d5b83",
		color: "#fff",
		fontWeight: "bold",
		fontSize: "11px",
		borderRight: "1px solid #fff",
		borderBottom: "2px solid #fff",
	};

	const cellStyle = {
		fontSize: "11px",
		padding: "5px",
		textAlign: "center",
		fontFamily: "Montserrat, sans-serif",

	};

	const centerStyle = {
		...cellStyle,
		textAlign: "center",
	};

	// * ACTIONS
	const actions = (rowData) => (
		<div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
			<Button
				color="primary"
				size="sm"
				onClick={() => handleUpdate(rowData)}
				disabled={loading}
				style={{
					padding: "2px",
					fontSize: "1rem",
					height: "26px",
					width: "26px",
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}}
			>
				<i className="fa fa-edit"></i>
			</Button>

			<Button
				color="danger"
				size="sm"
				onClick={() => handleDelete(rowData)}
				disabled={loading}
				style={{
					padding: "2px",
					fontSize: "1rem",
					height: "26px",
					width: "26px",
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}}
			>
				<i className="fa fa-trash"></i>
			</Button>
		</div>
	);




	return (
		<>
			<Fragment>
				<Container fluid={true} className="p-4 p-l-0 p-r-0" style={{ scrollBehavior: "smooth", transform: "scale(0.8)", width: "125%", transformOrigin: "top left" }}>
					<Row>
						<Col sm="12">
							<Card>
								<CardBody className="p-1">
									<Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
										<TitleDataTable
											titleTable="Catálogo de Control y Calidad"
											buttonActions={exportExcel}
											titleButton="Descargar listado"
											isDisbled={false}
											titleCreate="Crear convenio"
											buttonActionsCreate={handleCreate}
											actionInput={setGlobalFilter}
											valueFilter={globalFilter}
										/>
									</Col>

									<Col sm="12">
										<div className="table-responsive">
											<DataTable
												value={filterData(listQuality, globalFilter)}
												paginator
												rows={10}
												rowsPerPageOptions={[10, 20, 50]}
												className="data-table p-datatable-striped p-datatable-sm"
												responsiveLayout="scroll"
												emptyMessage={
													<div className="text-center">
														<img
															src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
															style={{ width: "35%" }}
															alt="Sin resultados"
														/>
														<br />
														<p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
															No hay coincidencias con la búsqueda.
														</p>
													</div>
												}
											>
												<Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
												<Column field="quality_controL" header="Control de calidad" headerStyle={headerStyle} style={centerStyle} />
												<Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
											</DataTable>
										</div>
									</Col>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
				{
					// * DIALOG
				}
				<ModalQuality
					{
					...{
						loading,
						visible,
						method,
						saveCreateCharacteristic,
						saveUpdateCharacteristic,
						setVisible,
						tittleDialog,
						formValues,
						handleInputChange,
						validaciones,
						saveDelete
					}
					}
				/>

				{
					//? ALERT GLOBAL
				}
				<ToastAletGlobal
					visible={showToast}
					type={toastType}
					title={toastTitle}
					message={toastMessage}
					onClose={closeToastAlert}
				/>

			</Fragment>
		</>
	)
}


